export default theme => ({
  root: {
    padding: "2rem"
  },
  card: {
    maxWidth: 345
  },
  centerGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  media: {
    height: 140,
    backgroundSize: "contain"
  },
  link: {
    textDecoration: "none"
  },
  btn: {
    width: "40%",
    padding: "20px",
    margin: "1%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "0 0 1% 0"
    }
  },
  containerActionBtns: {
    justifyContent: "flex-end",
    padding: "0 5% 0 0",
    spacing: "8",
    [theme.breakpoints.down("lg")]: {
      padding: "0 4% 0 0%"
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 4% 0 0%"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 6% 0 4%"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0 6% 0 8%"
    }
  },
  containerBackBtns: {
    padding: "0% 0% 0% 5%",
    [theme.breakpoints.down("lg")]: {
      padding: "0 5% 0 4%"
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 2% 0 4%"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0 6% 0 4%"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0 6% 0 8%"
    }
  }
});
